import { Icon } from '@iconify/react'

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip.jsx'

import { cn } from '@/lib/utils'

// Top-level areas. Keys are shared with MainSidebar's area routing.
// labelWidth is pinned to each label's real rendered text width so the
// active pill's expand and the previous pill's collapse mirror each other —
// the row width stays constant mid-switch and the other icons don't shift.
export const SIDEBAR_AREAS = [
    { key: 'reporting', label: 'Reporting', icon: 'lucide:bar-chart-3', labelWidth: 'max-w-[60px]' },
    { key: 'discovery', label: 'Discovery', icon: 'lucide:compass', labelWidth: 'max-w-[60px]' },
    { key: 'api', label: 'API & MCP', icon: 'lucide:code-2', labelWidth: 'max-w-[76px]' },
]

// Notion-style area switcher: a row of icons where only the active area
// reveals its text label; the others stay icon-only with a hover tooltip.
// The label reveal is a CSS max-width/opacity transition (not a JS width
// animation) so switching areas glides instead of jumping. Every button
// stays wrapped in the same Tooltip structure so the element persists
// across active↔inactive and the transition actually runs (only the
// tooltip content toggles).
export const SidebarAreaSwitcher = ({ activeArea, onSelect }) => {

    return (
        <TooltipProvider delayDuration={0}>
            <div className="flex items-center gap-1 px-3 pt-1 pb-2">
                {SIDEBAR_AREAS.map(area => {
                    const isActive = area.key === activeArea

                    return (
                        <Tooltip key={area.key}>
                            <TooltipTrigger asChild>
                                <button
                                    type="button"
                                    aria-label={area.label}
                                    onClick={() => onSelect(area.key)}
                                    className={cn(
                                        'flex items-center rounded-lg px-2 py-1.5 text-[13px] font-medium transition-colors',
                                        isActive ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-accent hover:text-foreground'
                                    )}
                                >
                                    <Icon icon={area.icon} className="h-4 w-4 shrink-0" />
                                    <span
                                        className={cn(
                                            'overflow-hidden whitespace-nowrap transition-all duration-200 ease-out',
                                            isActive ? cn('ml-1.5 opacity-100', area.labelWidth) : 'ml-0 max-w-0 opacity-0'
                                        )}
                                    >
                                        {area.label}
                                    </span>
                                </button>
                            </TooltipTrigger>
                            {!isActive && (
                                <TooltipContent side="bottom" className="bg-slate-800 text-white text-xs">
                                    {area.label}
                                </TooltipContent>
                            )}
                        </Tooltip>
                    )
                })}
            </div>
        </TooltipProvider>
    )
}
